import Maker from '../Maker/maker';

export default Maker;